"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToPage = void 0;
/* istanbul ignore file */
const goToPage = page => window.location.href = page;
exports.goToPage = goToPage;